export default {
  login: {
    loginType: 'Password login'
  }
};
